export const TRANSLATIONS_NO = {
  login: {
    username: 'Brukernavn',
    password: 'Passord',
    login: 'Logg inn',
    guest: 'Fortsett som gjest',
    back: 'Tilbake til påloggingsskjerm',
    sevenDigitPin: '7-sifret PIN',
    scan: 'Skann kortet ditt for pålogging ',
    ticket: 'Skann billetten din for å sjekke den ut ',
    switchStageLabel:
      'Du er på {{current}} — klikk her for å bytte til {{target}}',
    switchStageTitle: 'Bytte til {{target}}?',
    switchStageMessage:
      'Er du sikker på at du vil bytte stage? Dette vil starte alle terminaler på kontoret på nytt. Hvis du ikke er på kontoret, vil du ikke se noen endring.',
    switchStageSwitching: 'Bytter…',
    switchStageSuccess:
      'Bytter til {{target}}. Terminaler på kontoret starter på nytt…',
    switchStageError: 'Kunne ikke bytte stage. Vennligst prøv igjen.',
  },
  header: {
    sales: 'Salgs',
    newMember: 'Nytt Medlem',
    searchMember: 'Søk Medlemmer',
    onlinePayment: 'Online Utbetaling',
    onlinePaymentHistory: 'Online Utbetaling Historikk',
    report: 'Rapport',
    playerWithBalanceReport: 'Spiller med balanse rapport',
    adminReport: 'Admin Rapport',
    openTickets: 'Billetter i dag',
    ticketHistoric: 'Brukerens historikk',
    recent: 'Siste salg',
    endShift: 'Avslutte skiftet',
    endShiftMessage: 'Vil du avslutte skiftet?',
    lastTransactions: 'Siste trans.',
    lastCardTransactions: 'Kort trans.',
    specialGame: 'Spesial spill',
    specialGameSubtitle: 'Skriv premiebeløpet',
    specialGameAvailable:
      'Spesialspill er i ferd med å starte, vær oppmerksom på betalingen',
    specialGameMessage: 'Dette vil endre premien for det siste spillet til',
    specialGameMessageConfirm: 'Betalingen har blitt utført vellykket',
    specialGameMessageConfirmNoPrize:
      'Spesialspillet er avsluttet uten vinnere',
    specialGameMessageError: 'Det er ikke noe åpent spesialspill',
    printLastTrans: 'Skriv ut siste salg',
    userLimits: 'Spillgrenser',
    userLimitsMenuTitle: 's spillgrenser',
    ticketList: 'Billett liste',
    openCashier: 'Åpne kontant skuffen',
    refund: 'Refusjon',
    cashMovement: 'Kasse bevegelse',
    safe: 'Safe',
    gameplan: 'Spillplan',
    mysteryWinners: 'Mysterie vinnere',
    terminals: 'Terminaler',
  },
  kiosk: {
    comeBack: 'Tilbake',
    kioskBlock: 'Dette salgsstedet er deaktivert.',
    kioskBlockMessage1: 'Dette salgsstedet er ikke tilordnet noen bingohall.',
    kioskBlockMessage2:
      'Hvis du leser denne meldingen, vennligst kontakt support.',
    wrongUserTitle: 'Bruker ikke funnet',
    wrongUserMessage1:
      'Vi kunne ikke finne noen bruker med disse påloggingsopplysningene i systemet.',
    wrongUserMessage2:
      'Vennligst kontroller informasjonen du har oppgitt, eller kontakt kundestøtte.',
    orderList: 'Min ordre',
    total: 'Totalt',
    done: 'Ferdig',
    guest: 'Gjest',
    phonenumber: 'Telefonnummer',
    sevenDigitPin: '7-sifret PIN',
    logout: 'Logg ut',
    clear: 'Tøm',
    price: 'Pris',
    totalPrice: 'Totalpris',
    tickets: 'Billetter',
    delete: 'Slett',
    confirmLogoutTitle: 'Er du sikker på at du vil logge ut?',
    confirmLogoutMessage:
      'Du har ventende transaksjoner som vil bli kansellert hvis du logger ut.',
    pageIndicator: 'Side {{current}} / {{total}}',
    noGamesAvailable: 'Ingen spill tilgjengelig',
    priceCardLabel: 'Kortpris',
    gameLabel: 'Spill',
    confirmPaymentTitle: 'Betalingsmetode',
    confirmPaymentMessage: 'Hvordan vil du betale den nåværende bestillingen?',
    payWithCard: 'Betal med kort',
    payWithSaldo: 'Betal med saldo',
    currentSaldo: 'Nåværende saldo',
    paymentNotAvailable: 'Ikke tilgjengelig',
    waitingForCard: 'Venter på kortlesing',
    paymentSuccess: 'Betalingen har blitt utført vellykket',
    errorPaymentTitle: 'Det oppsto en feil med betalingen',
    errorPaymentMessage:
      'Noe gikk galt under betalingsprosessen, vennligst prøv igjen eller bruk en annen betalingsmetode.',
    blockedToBuyDataBingoInUse:
      'Billetten er i bruk på en annen maskin og kan ikke avsluttes.',
    blockedToBuyDataBingoTitle:
      'Du har ikke lov til å kjøpe flere databingobilletter',
    blockedToBuyDataBingoMessage:
      'Du har nådd grensen for å kjøpe databingobilletter.',
    blockedToBuyDataBingoZeroBalance:
      'Den eksisterende billetten har ingen saldo. Hvis du vil opprette en ny, må du først lukke denne billetten.',
    blockedToBuyDataBingoCloseTicket: 'Lukk billett',
    limitSurpassedTitle: 'Grense overskredet',
    limitSurpassedMessage:
      'Du har overskredet grensen for å kjøpe billetter. Vennligst juster kjøpet ditt deretter.',
    infoTicketTitle: 'Billettinformasjon',
    infoTicketMessage1: 'Nåværende saldo: ',
    infoTicketMessage2:
      'Hvis du er eieren av denne billetten, kan du fylle den på ved å logge inn.',
    infoTicketMessage3: 'Hvis du vil betale den ut, vennligst gå til kassen.',
    infoTicketErrorTitle: 'Ugyldig billett',
    infoTicketErrorMessage:
      'Den skannede billetten er ikke gyldig eller kunne ikke bli funnet. Vennligst prøv med en annen billett.',
    closedTicketTitle: 'Billett stengt',
    closedTicketMessage1: 'Denne billetten er stengt og kan ikke brukes.',
    closedTicketMessage2: 'Vennligst kontakt kassen for mer informasjon.',
    usedTicketTitle: 'Billett er i bruk',
    usedTicketMessage1:
      'Denne billetten er for øyeblikket i bruk på en maskin.',
    usedTicketMessage2:
      'Billetten må logges ut fra maskinen før den kan brukes her.',
    selectTicket:
      'Vennligst velg en billett først før du velger beløpet for påfylling.',
    infoTicketErrorPinMessage:
      'PIN-koden er ikke korrekt, vennligst prøv igjen.',
    confirmPinTitle: 'Bekreft din identitet',
    confirmPinMessage1:
      'For å la deg operere med denne kontoen, må vi bekrefte din identitet.',
    confirmPinMessage2:
      'Vennligst skriv inn din 4-sifrede PIN-kode for å fortsette.',
    outOfPaperTitle: 'Skriveren har gått tom for papir',
    outOfPaperMessage:
      'Skriveren har gått tom for papir. Vennligst kontakt support for å løse dette problemet.',
    paperLowTitle: 'Papir holder på å gå tomt',
    paperLowMessage:
      'Skriveren er i ferd med å gå tom for papir. Fyll på snart for å unngå avbrudd.',
    printerOfflineTitle: 'Skriveren er frakoblet',
    printerOfflineMessage:
      'Skriveren er ikke tilgjengelig. Sjekk tilkoblingen eller kontakt support.',
    transactionGameExpired:
      'Ett eller flere spill har passert sin kjøpsfrist og ble fjernet fra handlekurven.',
    cutoffRemaining: 'Stenger om',
  },
  sales: {
    checkCard: 'Sjekk',
    openShiftTitle: 'Åpne skift ikke funnet',
    openShiftText:
      'Ingen åpne skift ble funnet for denne terminalen. Et nytt skift vil bli opprettet hvis du fortsetter.',
    cashOnOpening: 'Kontantbeholdning ved åpning',
    openShiftOperator: 'Operatør',
    openShiftHall: 'Hall',
    openShiftConfirmTitle: 'Bekreft kontantbeholdning',
    openShiftAmountLabel: 'Du åpner dagen med',
    openShiftCountedQuestion: 'Bekrefter du at du har talt kassen?',
    openShiftBack: 'Tilbake',
    cashMovementTitle: 'Kassebevegelse',
    cashMovementSubtitle: 'Hva slags bevegelse gjelder det?',
    cashMovementRefund: 'Refusjon til spiller',
    cashMovementOut: 'Ta ut av kassen',
    cashMovementIn: 'Sett inn i kassen',
    cashMovementSafe: 'Safe og mini safe',
    cashMovementKiosk: 'Kiosksalg',
    kioskProductsTitle: 'Solgte kioskvarer',
    kioskProductsShift: 'Dette skiftet',
    kioskProductsDay: 'Hele dagen',
    kioskProductsProduct: 'Vare',
    kioskProductsQty: 'Antall',
    kioskProductsTotal: 'Sum',
    kioskProductsEmpty: 'Ingen kioskvarer solgt',
    kioskProductsCancelled: '{{count}} kansellert',
    kioskProductsCount: '{{count}} varer',
    cashMovementAmount: 'Beløp',
    cashMovementReason: 'Årsak',
    cashMovementReasonHelp:
      'Skriv hva pengene gikk til eller kom fra. Kort holder.',
    cashMovementReasonRequired: 'Årsak må fylles ut.',
    cashMovementAmountRequired: 'Skriv inn et beløp.',
    cashMovementNoPlayer: 'Velg en spiller først for å gjøre en refusjon.',
    cashMovementDone: 'Bevegelsen er registrert.',
    handoverTitle: 'Overtatt fra forrige skift',
    handoverSignedBy: 'Signert av',
    handoverClosedAt: 'Lukket',
    handoverAvvik: 'Avvik ved forrige lukking',
    openingAvvik: 'Differanse mot forrige lukking',
    openingMatches: 'Stemmer med forrige lukking',
    openingCommentLabel: 'Hva fant du?',
    openingCommentHelp:
      'Tell gjerne en gang til først. Skriv det du fant — du var ikke på forrige skift.',
    openingCommentRequired:
      'En differanse ved åpning må noteres før skiftet kan åpnes.',
    openingRecount: 'Tell på nytt',
    terminalsTitle: 'Terminaler',
    terminalsID: 'ID',
    terminalsType: 'Type',
    terminalsSoftReset: 'Myk tilbakestilling',
    terminalsReboot: 'Start på nytt',
    terminalsScreenshots: 'Skjermbilder',
    terminalsScreenshotsTitle: 'Skjermbilder — {{deviceType}} {{id}}',
    terminalsScreenshotsError:
      'Kunne ikke laste skjermbilder fra denne terminalen',
    terminalsScreenshotsFullscreen: 'Fullskjerm',
    terminalsBack: 'Tilbake',
    terminalsTypeFlash: 'Flash',
    terminalsTypeTerminal: 'Terminal',
    terminalsTypeKiosk: 'Selvbetjening',
    terminalsConfirmSoftResetTitle:
      'Myk tilbakestilling av {{deviceType}} {{id}}',
    terminalsConfirmRebootTitle: 'Omstart av {{deviceType}} {{id}}',
    terminalsConfirmSoftResetText:
      'Er du sikker på at du vil utføre en myk tilbakestilling av {{deviceType}} {{id}}? Vær oppmerksom på at ingen bruker den for øyeblikket.',
    terminalsConfirmRebootText:
      'Er du sikker på at du vil starte {{deviceType}} {{id}} på nytt? Vær oppmerksom på at ingen bruker den for øyeblikket.',
    terminalsActionSuccess: 'Handlingen ble utført',
    terminalsRebootAll: 'Start alle på nytt',
    terminalsSoftResetAll: 'Myk tilbakestilling av alle',
    terminalsConfirmSoftResetAllTitle: 'Myk tilbakestilling av alle terminaler',
    terminalsConfirmRebootAllTitle: 'Omstart av alle terminaler',
    terminalsConfirmSoftResetAllText:
      'Er du sikker på at du vil utføre en myk tilbakestilling av alle terminaler? Vær oppmerksom på at ingen bruker dem for øyeblikket.',
    terminalsConfirmRebootAllText:
      'Er du sikker på at du vil starte alle terminaler på nytt? Vær oppmerksom på at ingen bruker dem for øyeblikket.',
    noData: 'Ingen data tilgjengelig',
    expiredPepTitle: 'PEP-bruker',
    expiredPepQuestionPep: 'Er brukeren fortsatt en PEP?',
    expiredPepQuestionNotPep: 'Er brukeren fortsatt ikke en PEP?',
    expiredAddressTitle: 'Adressedetaljer',
    expiredAddressQuestion: 'Er brukerens adresse fortsatt den samme?',
    expiredAddressValues:
      'Land: {{country}}, Postnummer: {{postalCode}}, Gateadresse: {{streetAddress}}',
    expiredContactTitle: 'Kontaktdetaljer',
    expiredContactQuestion: 'Er brukerens telefonnummer fortsatt det samme?',
    expiredContactValues: 'Telefonnummer: {{mobile}}',
    expiredBack: 'Tilbake',
    userID: 'Bruker ID',
    gameID: 'Spill ID',
    bingoName: 'Bingohall',
    date: 'Dato og tid',
    winnerCard: 'Vinner Billett',

    noMysteryWinnersTitle: 'Ingen mysterie vinnere funnet',
    noMysteryWinnersText:
      'Det er ingen mysterie vinnere å vise for øyeblikket.',
    expiredTitle: 'Brukerens informasjon er utløpt',
    expiredText:
      ' Brukerens informasjon har utløpt og må oppdateres før du fortsetter.',
    unlockTitle: 'Lås opp brukeren',
    unlockText1: 'Du skal låse opp denne brukeren. Detaljene er:',
    unlockText2: 'Er du sikker på at du vil låse opp denne brukeren?',
    unlockedTitle: 'Brukeren ble låst opp.',
    unlockedText: 'Trykk bekreft for å fortsette.',
    lockTitle: 'Denne brukeren er ikke låst',
    lockText1: 'Denne brukeren er ikke låst, du kan selge som vanlig.',
    lockText2: 'Trykk bekreft for å fortsette.',
    cashin: 'Innskudd',
    cashout: 'Uttak',
    rollover: 'Videreførte gevinster',
    totalSpentDay: 'Totalt brukt',
    limitsPerDay: 'Dagsgrenser',
    winnings: 'Gevinster',
    description: 'Beskrivelse',
    winnings: 'Gevinster',
    refund: 'Refusjonsbeløp',
    refundCash: 'i kontanter',
    refundLimits: 'Tar hensyn til brukerens grenser',
    refundReason: 'Årsak',

    bet: 'Innsats',
    cards: 'Bonger',
    betAndCardsMustBeSelected: 'Innsats og bonger må velges før salg',
    sell: 'Selg',
    selectGameAndCards: 'Velg spill og bonger',
    confirmAndContinue: 'Bekreft og fortsett',
    done: 'Ferdig',
    confirmPapirBatchText:
      'Selge {{cards}} bonger for spill <hl>{{games}}</hl> for totalt <hl>{{total}} kr</hl>?',
    confirmBatchWithBet:
      'Selge {{cards}} bonger med innsats {{bet}} for spill <hl>{{games}}</hl> for totalt <hl>{{total}} kr</hl>?',
    confirmPapirBatchWithPrice:
      'Selge {{cards}} bonger à {{price}} kr for spill <hl>{{games}}</hl> for totalt <hl>{{total}} kr</hl>?',
    confirmKingoSaleTitle: 'Bekreft salget',
    confirmKingoSaleText1: 'Du skal selge ',
    confirmKingoSaleText2: ' kort med en innsats på ',
    confirmKingoSaleText3: ' hver, for totalt ',
    confirmKingoSaleText4: 'Vil du fortsette?',
    gameSelector: 'Spillvalg',
    confirmAndClose: 'Bekreft og lukk',
    backToMainScreen: 'Tilbake til salg',
    startTime: 'Starttid: ',
    papirInstructions:
      'Skann kortene, så håndterer systemet salget automatisk. Hvis du må annullere et kort, gjør det før du går tilbake til hovedskjermen',

    papirBatchTitle: 'Liste over skannede billetter',
    papirBatchText1:
      'Følgende billetter er skannet på denne kvitteringen. Hvis du vil betale ut, skann vinnerbilletten:',
    papirBatchText2:
      'Følgende billetter er skannet på denne kvitteringen. Hvis du vil betale ut, vennligst gå til kassen:',
    papirBatchNotFinished: 'Ikke fullført',
    papirBatchNotPrize: 'Ingen premie',
    papirBatchPrize: 'Premie: ',
    papirBatchInvalidHall: 'Ugyldig hall',

    price: 'Pris: ',
    papirTicketAlreadySoldTitle: 'Denne billetten er allerede solgt',
    papirTicketAlreadySoldText:
      'Hvis du vil sjekke resultatene, skann billetten på nytt på hovedskjermen',

    papirTicketNotSoldTitle: 'Denne billetten er ikke solgt i dag',
    papirTicketNotSoldText1:
      'Den skannede billetten er ikke solgt og er ikke knyttet til noen bruker i dag.',
    papirTicketNotSoldText2:
      'Hvis du vil selge den, gå til Papirbingo-skjermen.',
    papirTicketNotSoldText3:
      'De siste 7 dagene har denne billetten følgende historikk:',
    papirTicketAmount: 'Beløp',

    papirTicketTransaction: 'Transaksjon',
    papirTicketDate: 'Dato',
    papirTicketGameID: 'Spill-ID',
    papirTicketSold: 'Solgt',
    papirTicketCancel: 'Kansellert',
    papirTicketPrizes: 'Gevinster',
    papirTicketPrizesPayout: 'Gevinstutbetaling',

    papirGameNotFinishedTitle: 'Dette spillet er ikke ferdig',
    papirGameNotFinishedText1:
      'Spillet som er knyttet til denne billetten er ikke spilt ennå.',
    papirGameNotFinishedText2: 'Spill nummer ',
    papirGameNotFinishedText3: ' starter kl: ',
    papirGameNotFinishedText4:
      'Sjekk igjen senere for å se om billetten har noen premie.',

    restoreSaleTitle: 'Uavsluttet salg funnet',
    restoreSaleText1:
      'Skjermen ble lukket midt i et salg. Salget ble lagret på denne maskinen.',
    restoreSaleClient: 'Kunde: ',
    restoreSaleNoUser: 'ingen kunde',
    restoreSaleOperator: 'Registrert av: ',
    restoreSaleTime: 'Tidspunkt: ',
    restoreSaleLines: 'Linjer: ',
    restoreSaleTotal: 'Sum: ',
    restoreSaleQuestion: 'Vil du gjenopprette salget?',
    restoreSaleYes: 'Gjenopprett',
    restoreSaleNo: 'Forkast',

    papirTicketNotValidTitle: 'Denne billetten er ikke gyldig for salg',
    papirTicketNotValidText1: 'Den skannede billetten er ikke gyldig for salg.',
    papirTicketNotValidText2: 'Årsak: ',
    papirTicketNotValidText3: 'Vennligst prøv med en annen billett.',
    papirTicketNotValidReasonPrice:
      'Billettypen er ikke riktig for det valgte spillet.',
    papirTicketNotValidReasonHall:
      'Denne billetten gjelder ikke i denne hallen.',
    papirTicketNotValidReasonPriceAndHall:
      'Billettypen er ikke riktig for det valgte spillet, og den gjelder ikke i denne hallen.',

    papirGameFinishedWithPrizeTitle: 'Denne billetten har en premie',
    papirGameFinishedWithPrizeText1: 'Denne billetten har følgende premier:',
    papirGameFinishedWithPrizeText2: 'Vil du løse inn premiene?',
    papirGameFinishedWithPrizeText3:
      'Vennligst gå til kassen for å gjøre utbetalingen.',
    papirGameFinishedWithoutPrizeTitle: 'Denne billetten har ingen premie',
    papirGameFinishedWithoutPrizeText1:
      'Denne billetten har ingen premie i dette spillet.',
    papirGameFinishedWithoutPrizeText2:
      'Hvis du vil sjekke en annen billett, skann den etter at du har lukket denne dialogen.',

    papirCheckCardTitle: 'Kortsjekk',
    papirCheckCardSubtitle: 'Spill av trekningen for å kontrollere kortet',
    papirCheckCardDrawnBalls: 'Trukne rop',
    papirCheckCardLastBall: 'Siste rop',
    papirCheckCardWinningBall: 'Vinnerrop',
    papirCheckCardResult: 'Resultat',
    papirCheckCardStart: 'Start',
    papirCheckCardPrevious: 'Forrige',
    papirCheckCardNext: 'Neste',
    papirCheckCardPlay: 'Spill',
    papirCheckCardPause: 'Pause',
    papirCheckCardBallNumber: 'Rop',
    papirCheckCardCard: 'Kort',
    papirCheckCardGame: 'Spill',
    papirCheckCardMatches: 'Treff',
    papirCheckCardSummary: 'Kortoppsummering',
    papirCheckCardPatternBilde: 'Bilde',
    papirCheckCardPatternRamme: 'Ramme',
    papirCheckCardPatternBingo: 'Bingo',
    papirCheckCardNoPrize: 'Ingen premie på dette kortet',
    papirCheckCardTotal: 'Totalt',
    papirCheckCardLimit: 'grense',
    papirGameFinishedWithPrizeIsAlreadyPayed:
      'Denne billetten er allerede utbetalt',

    papirGameFinishedWithPrizeUserTotal: 'Totalt',
    papirGameFinishedWithPrizeUserMustBeLogin:
      'Beløpet er større enn 500. Vennligst identifiser brukeren før du gjennomfører utbetalingen.',

    paper: 'Papirbingo',
    countdownToNextGame1: 'Neste spill er ',
    countdownToNextGame2: ' og salget avsluttes om: ',
    transactions: 'Transaksjoner',
    printAction: 'Skriv Ut',
    scanMessage: 'Skann eller skriv inn brukernummeret',
    gameMustBeSelected: 'Du må velge et spill før du kan selge billetten',

    search: 'Søk medlemmer',
    searchMemberPin: 'Søk etter pin',
    searchMemberUsername: 'Søk etter brukernavn',
    searchMemberPhonenumber: 'Søk etter telefonnummer',
    autoSearch: 'Automatisk søk',
    searchByLastname: 'Søk etter etternavn',
    searchByFirstname: 'Søk etter fornavn',
    searchBySSNID: 'Søk etter fødselsnummer',
    deposit: 'Sett inn',
    depositSubtitle: 'På spillerkonto',
    withdraw: 'Ta ut',
    withdrawSubtitle: 'Fra spillerkonto',
    transfer: 'Overføring',
    transferSubtitle: 'Til bankkonto',
    newTicket: 'Ny Billett',
    payout: 'Utbetaling',
    scan: 'Skann',
    refill: 'Fylle på',
    product: 'Nytt produkt',
    cash: 'Contant',
    card: 'Kort',
    paymentCard: 'Fullfør kjøpet og betal med kort?',
    paymentCash: 'Fullfør kjøpet og betal kontant?',
    spillerkonto: 'Spillerkonto',
    printMovement: 'Konto-Utskrift',
    saldoUserAccount: ' Saldo på spillerkonto: ',
    newCardMessage:
      'Dette kortet er ikke registrert, vil du opprette en ny bruker?',
    yes: 'Ja',
    no: 'Nei',
    part: 'Delvis',
    partialAmount: 'Velg beløp',
    confirmAndStay: 'Bekreft og bli',
    confirm: 'Bekreft',
    cancel: 'Avbryt',
    close: 'Lukk',
    cardPaymentItem: 'Kontant uttak',
    confirmWG:
      'For å fortsette må du først fullføre operasjonen i Win Games-kassen.',
    confirmOK:
      'For å fortsette må du først fullføre operasjonen i OK Databingo-kassen.',
    confirmNT:
      'For å fortsette må du først fullføre operasjonen i Norsk Tipping-kassen.',
    NTInn: 'Inn',
    NTUt: 'Ut',
    total: 'Totalt',
    payCard: 'Mottat Kort',
    payCash: 'Mottat Contant',
    change: 'Tilbake',
    remaining: 'Gjenstående',
    paymentCardScreen: 'Betaling med kort',
    paymentCashScreen: 'Betaling med kontanter',
    paymentFullCard: 'Fyll inn hele summen',
    paymentFullCash: 'Fyll inn hele summen',
    amount: 'Beløp',
    endShop:
      'Bekrefter du at transaksjouserHasPasswordBlockText2nen er utført?',
    endShopByCard:
      'Bekrefter du at transaksjonen er utført? Etter bekreftelse, vent på brukerbetalingen',
    insufficientFunds: 'Transaksjonene er ikke betalt ennå',
    waiting: 'Venter på brukerbetalingen',
    cancelShop: 'Avbryt kjøp',
    print: 'Skriv ut kvittering',
    shortcuts: 'Hurtigknapper beløp',
    payCard: 'Betal med kort',
    payCardSingle: 'Enkel Betal med kort',
    payCash: 'Betal med Cash',
    payAccount: 'Betal med konto',

    payCHTitle: 'Betal med Spillerkonto',
    payCH: 'Spiller-Konto',
    payoutTicket: 'Åpne billetter',
    registerNewAnonUser: 'Ny anonym bruker',
    registerNewHybridUser: 'Ny daglig bruker',
    registerNewMember: 'Ny medlem',
    editHybridUser: 'Rediger daglig bruker',
    editMember: 'Rediger medlem',

    anonToUser:
      'Vil du redigere denne daglig brukeren eller gjøre den om til medlem?',
    hybridToUser:
      'Vil du redigere denne daglig brukeren eller gjøre den om til medlem?',
    optional: '(valgfri)',
    userTooSmall: 'Søk skal ha minst 7 sifre',
    userNotFound: 'Brukeren eksisterer ikke, vil du opprette en ny? ',
    usersFound: 'Mer enn en bruker er funnet',
    selectUser: 'Bruk denne brukeren',
    registerNewUserConfirm: 'Registrer ny bruker',
    editUserConfirm: 'Rediger bruker',
    editUserConfirmButton: 'Rediger',
    phonenumber: 'Telefonnummer',
    phonenumberMandatory: 'Telefonnummer (påbudt)',
    newUser: 'Ny dadlig bruker',
    newMember: 'Nytt medlem',
    newMemberText:
      'Kunde må bekrefte sin identitet, spør kunde hvilken metode vedkommende ønsker å bruker for å bekrefte sin identitet',
    newMemberButtonID: 'ID-Kort, Førerkort eller Pass',
    newMemberButtonBankID: 'BankID',
    updateHybridUser:
      'Dette er en daglig bruker, du kan redigere den eller registrere den som et nytt medlem:',
    lastUsers: 'Siste brukere',
    sellMessage: 'Husk å motta kontanter fra kunden før du trykker TOTAL',
    sellMessageCash1: 'Husk å ta ',
    sellMessageCash2: ' KR fra kunden. ',
    sellMessageReturnCash1: 'Husk å gi tilbake ',
    sellMessageReturnCash2: ' KR til kunden.',
    name: 'Navn',
    nameMandatory: 'Navn (påbudt)',
    surname: 'Etternavn',
    nameAndSurname: 'Navn og etternavn',
    unblock: 'Send bekreftelse til brukeren for å låse opp billettene',
    send: 'Send',
    unregistered: 'Uregistrert',
    registerAnonPlayer: 'Registrer den daglige brukeren',
    paymentAnon:
      'Daglige brukere kan kun betale med kort, vil du registrere denne daglige brukeren?',
    registerAnonPlayerConfirm: 'Registrer',
    transactionDone: 'Transaksjonen er fullført',
    backToPayment: 'Tilbake til betalingen',
    transactionFail: 'Transaksjonen mislyktes eller avvistes',
    smsTitle: 'Venter på bekreftelseskoden',
    smsText1:
      'En SMS med en bekreftelseskoden har blitt sendt til kundens mobilnummer for å bekrefte identiteten.',
    smsText2: 'Kunden må bekrefte pinkoden på skjermen.',
    pincodeTitle: 'Venter på brukerens pinkode',
    pincodeText1:
      'Brukeren bør introdusere den 4-sifrede pinkoden knyttet til kontoen sin: ',
    userConfirm: 'Bruker registrert vellykket',
    selected: 'Valgt',
    internetAccess: 'Forby internettilgang',
    chooseOne: 'Velg...',
    passport: 'Pass',
    driverLicense: 'Førerkort',
    electronicID: 'Electronic(BankID)',
    nationalID: 'Nasjonalt ID-kort',
    bankCard: 'Bankkort',
    other: 'Annet',
    terms: 'Vilkår for bruk og personvernerklæring',
    communication: 'Valg av kommunikasjonkanaler vi kan bruker',
    pincode: 'Uttakspinkode',
    newPincode: 'Ny pinkode',
    pincodeLabel: 'Uttakspinkode',
    cardID: 'Kort ID',
    nfcCardID: 'NFC Kort ID',
    ssnid: 'Fødselsnummer',
    username: 'Brukernavn',
    firstname: 'Fornavn',
    lastname: 'Etternavn',
    address: 'Adresse',
    verificationMethod: 'Verifiseringsmetode',
    country: 'Land',
    postalCode: 'Postnummer',
    region: 'Sted',
    email: 'E-post',
    birthdate: 'Fødselsdato',
    verificationID: 'Verifiserings-ID',
    bankAccount: 'Bankkonto',
    cashoutPending: 'Brukeren har en ventende utbetaling:',
    cashoutNow: 'Utbetale nå',
    signatureTitle: 'Signatur kreves',
    signatureText:
      'Gjeldende transaksjon må signeres for å bli godkjent. Venter på brukerens signatur.',
    signatureTitleID: 'ID-bekreftelse påkrevd',
    signatureTextID:
      'En ID-bekreftelse er påkrevd for å fortsette. Ta et bilde av brukerens ID for å verifisere brukerens identitet.',
    signatureConfirmSMS: 'En pinkode vil bli sendt til brukerens telefon',
    signatureUserNeedsMobile:
      'Denne brukeren har ikke registrert et telefonnummer. Et telefonnummer er obligatorisk for å fortsette. ',
    signatureConfirm: 'Transaksjoner godkjent',
    openSessionTitle: 'Åpen økt funnet',
    openSessionText1: 'Denne billetten har en åpen økt i terminalen ',
    openSessionText2: ' med en total mengde ',
    openSessionTextClose: 'Vil du lukke økten?',
    openSessionTextUnclosable: 'Denne økten må lukkes i terminalen først',
    chooseProduct: 'Velg produkt',

    ticket7Pincode: 'Billet Pincode',
    currentSaldo: 'Gjeldende saldo',
    editHybridToFull: 'Gjør om til medlem',
    userLimits: 'Totalgrenser',
    noLimits: 'Ingen begrensning',
    cashIn: 'Innskudd',
    cashOut: 'Uttak',
    limitsUpdated: 'Begrensningene for denne brukeren ble oppdatert',
    cardToCash: 'Kontant uttak',
    limitDaily: 'Daglig grense',
    limitMonthly: 'Månedlig grense',
    isLimitSurpassed: 'Grensen er overskredet',
    isLimitSurpassedDaily:
      'Denne brukeren har overskredet grensen og har ikke lov til å spille mer i dag',
    isLimitSurpassedMonth:
      'Denne brukeren har overskredet grensen og har ikke lov til å spille mer denne måneden',
    isVerificationNeeded: 'Verifisering er nødvendig',
    isVerificationNeededText1:
      'Brukerprofilen mangler flere viktige opplysninger og må verifiseres for å fortsette.',
    isVerificationNeededText2:
      'Vennligst rediger brukeren for å verifisere den.',

    isLimitSurpassedTransaction1:
      'Den nåværende transaksjonen er ikke tillatt fordi den overstiger brukerens grense. ',
    isLimitSurpassedTransaction2: 'Det maksimale beløpet som er tillatt er: ',

    ticketWithDifferentParentTitle:
      'Denne billetten tilhører ikke denne brukeren',
    ticketWithDifferentParentText:
      'Denne billetten tilhører en annen bruker, vil du foreta utbetalingen til den nåværende brukeren?',
    photoVerificationTitle: 'Bekreft kundens identitet',
    photoVerificationText:
      'Bruk profilbildet for å bekrefte kundens identitet, ta et nytt bilde, be kunden om å taste inn PIN-koden for uttak eller bekreft at du kjenner kunden for å fortsette.',
    photoVerificationTextHybrid:
      'Bruk profilbildet for å bekrefte kundens identitet, ta et nytt bilde eller bekreft at du kjenner kunden for å fortsette.',
    photoUploadTitle: 'Ta bildet',
    photoUploadText:
      'Bruk et av kameraene til å ta et bilde av brukerens ansikt eller et annet gyldig dokument, som pass eller ID-kort.',
    photoUploadTextSignature:
      'Bruk et av kameraene til å ta et bilde av brukerens gyldig dokument, som pass eller ID-kort.',
    photoUploadSuccess: 'Bildet ble lastet opp',
    userVerificationImage: 'Brukerverifiseringsbilde',
    userVerificationImageNew: 'Ta et nytt bilde',
    saldo: 'Saldo',
    status: 'Status',
    open: 'Åpen',
    closed: 'Lukket',
    inGame: 'I spill',
    editUserBlock: 'Fullfør den nåværende operasjonen for å redigere brukeren',
    bigNumberConfirmTitle: 'Transaksjon over 10.000',
    bigNumberConfirmText1:
      'Beløpet for denne transaksjonen er høyere enn vanlig, vil du fortsette?',
    bigNumberConfirmText2: 'Totalbeløp: ',
    deleteUser: 'Slett',
    banUser: 'Deaktiver',
    banUserTitle: 'Deaktiver bruker',
    banUserText:
      'Er du sikker på at du vil deaktivere denne brukeren? Velg årsaken og hvor lenge du vil deaktivere brukeren.',
    banUserTextConfirm: 'Du er i ferd med å deaktivere brukeren for: ',
    banUserTextConfirmSuccess:
      'Brukeren har blitt utestengt. For å aktivere den igjen, kontakt support.',
    banUserReason: 'Årsak',
    banUserReasonPlaceholder: 'Velg en årsak',
    banUserDuration: 'Varighet',
    banUserDurationPlaceholder: 'Velg en varighet',
    deleteUserTitle:
      'Du er i ferd med å slette denne brukeren, er du sikker på at du vil fortsette?',
    deleteUserConfirm: 'Brukeren har blitt slettet',
    closeSellerOrPayment:
      'Fullfør den nåværende operasjonen eller gå tilbake til hovedskjermen for å skanne en ny billett',
    invalidTicket: 'Ugyldig billett',
    userSignatureCheckTitle: 'Identitetskontroll kreves',
    userSignatureCheckText:
      'Be kunden om et gyldig dokument for å verifisere signaturen. Husk at du må ta et bilde av dokumentet hvis du godkjenner signaturen.',
    newSpecialGameLuckyDay: "Ny 'Lucky Day' rulett",
    newSpecialGameLuckyDayText1:
      "En ny 'Lucky Day' rulett har blitt spilt i denne hallen.",
    newSpecialGameLuckyDayText2:
      'Brukeren må matche nummeret på ruletten med dagens dato for å vinne premien.',
    newSpecialGameLuckyDayText3: 'I dag er: ',
    newSpecialGameLuckyDayText4: 'Har brukeren fått riktig nummer?',
    restart: 'Starte på nytt',
    switchCamera: 'Bytt kamera',
    specialGameMessageNoPrizeConfirm:
      'Brukeren har ikke vunnet spesialpremien, og spillet vil betale standard bingopremie og bildes og rammes hvis de finnes. Vil du fortsette?',
    termsSignature:
      'For å fortsette og lagre brukerens signatur, må brukeren godta personvernreglene og akseptere at ID-en vil bli lagret i våre systemer i opptil to år.',
    signatureStored: 'Signatur lagret',
    signatureStoredText:
      'Brukeren har allerede en lagret gyldig identifikasjon, sjekk brukerens identitet og bekreft for å fortsette transaksjonen.',
    signatureStoredDate: 'Identifikasjon lagret den',
    postponeIdentification: 'Utsett identifikasjon',
    postponeIdentificationText:
      'Utsett identifikasjonen for denne transaksjonen og fortsett med betalingen (brukeren må verifisere identifikasjonen innen de neste 2 ukene.)',
    ticketClosedOK: 'Billetten er allerede lukket',
    waitingForScan: 'Venter på kortskanning',
    waitingForScanText:
      'Skann ett av CH-kortene for å knytte det til denne brukeren automatisk',
    pep: 'P.E.P. eller nært familiemedlem med en P.E.P.*',
    waitingForUser: 'Venter på bruker',
    waitingForUserTerms: 'Brukeren må godkjenne brukervilkårene',
    waitingForRiskyInfo: 'Brukeren må gi ekstra informasjon',
    waitingForUserCommunication:
      'Brukeren må velge kommunikasjonskanaler vi kan bruke',
    waitingForUserPEP:
      'Brukeren må bekrefte om han er en P.E.P. og fylle ut skjemaet',
    waitingForUserPincodeTitle: 'Venter på brukerens pinkode',
    waitingForUserPincodeText:
      'Brukeren bør introdusere den 4-sifrede pinkoden knyttet til kontoen sin',
    newMemberBankID:
      'Kunden vil motta en SMS med en lenke for å registrere seg med BankID.',
    smsSent:
      'En SMS med en lenke for å registrere og identifisere brukeren har blitt sendt til brukerens telefonnummer',
    importantTitle: 'Viktig kunngjøring',
    importantSubtitle:
      'Fra og med 1. januar 2025 må alle daglige brukere være registrert med gyldig ID som medlemmer. Hvis brukeren ikke kan registrere seg med gyldig ID akkurat nå, fortsett ved å avbryte denne kunngjøringen.',
    iKnowTheUser: 'Kjenner kunden eller ID OK',
    identityConfirm: 'Bekreft brukerens identitet',
    countryOfResidence: 'Land',
    confirmPicture: 'Bekreft bilde',
    continueWithoutRegister: 'Fortsett uten å registrere',
    registerAsMember: 'Registrer som medlem',

    waitingForApproval: 'Venter på godkjenning',
    waitingForApprovalText:
      'Denne brukeren trenger manuell godkjenning, kontakt support.',
    suspectedFraud: 'Mistenkt svindel',
    maxFailedLoginAttempts: 'Maks antall mislykkede påloggingsforsøk',
    incorrectPersonalInformation: 'Feil personlig informasjon',
    otherBanned: 'Andre',
    underaged: 'Under 18 år',
    hrl: 'HRL',
    pepBanned: 'PEP',
    badBehaviour: 'Dårlig oppførsel',
    selfExclusionFor1Month: 'Selvutestengelse i 1 måned',
    selfExclusionFor3Months: 'Selvutestengelse i 3 måneder',
    selfExclusionFor6Months: 'Selvutestengelse i 6 måneder',
    selfExclusionFor1Year: 'Selvutestengelse i 1 år',
    deletedAccount: 'Slettet konto',
    userIsNotAllowed: 'Brukeren er sperret',
    time1week: '1 uke',
    time1month: '1 måned',
    time3months: '3 måneder',
    time6months: '6 måneder',
    time1year: '1 år',
    riskyCountryTitle: 'Du må oppgi tilleggsinformasjon',
    riskyCountry:
      'Du er fra et land som krever manuell godkjenning og ekstra informasjon for å fortsette.',
    residence: 'Bosted',
    reason: 'Grunn: ',

    confirmLogin: 'Bekreft kundens identitet',
    confirmLoginText:
      'Bruk profilbildet for å bekrefte kundens identitet, ta et nytt bilde, be kunden om å taste inn PIN-koden for uttak eller bekreft at du kjenner kunden for å fortsette.',
    confirmLoginNewMember: 'Nytt bilde',
    confirmLoginPincode: 'Uttak-PIN',
    confirmLoginIKnowTheUser: 'Kjenner el. ID OK',
    sendPincodeBySMS: 'Send pinkode via SMS',
    sendPincodeBySMSText:
      'Brukerens PIN-kode har blitt sendt til brukerens telefonnummer',
    createNewUser: 'Nytt medlem',
    sendOneTimeCodeBySMS: 'Engangskode via SMS',
    newConfirmTitle: 'Brukeren har bekreftet sin identitet',
    newConfirmText:
      'Brukeren har brukt sin uttak PIN-kode for å bekrefte sin identitet, trykk på bekreft for å fortsette',
    sellBlockedTitle: 'Brukeren har åpne billetter',
    sellBlockedText:
      'Brukeren har åpne billetter og har ikke lov til å kjøpe flere billetter før de åpne billettene er lukket',
    sellBlockedOpenTickets: 'Åpne billetter:',
    sellBlockedOpenSessions: 'Åpne sesjoner i',
    sellBlockedOpenTerminal: ' terminal: ',
    sellBlockedOpenBingoHall: ' hall: ',
    sellBlockedOpenBingoGame: ' spill: ',
    ticketClosed: 'Billetten lukket',
    closeTicket: 'Lukk billett',
    closeTicketConfirmTitle: 'Lukk billett',
    closeTicketConfirmMessage:
      'Er du sikker på at du vil lukke denne billetten?',
    platform: 'Plattform',
    platformKiosk: 'Selvbetjeningskiosk',
    platformCashier: 'Kasse',
    provider: 'Leverandør',
    dateCreated: 'Opprettet',
    dateClosed: 'Lukket',
    dateLastRecord: 'Siste registrering',
    searchTicket: 'Søk etter billett',
    allProviders: 'Alle leverandører',
    ticketInUse: 'I bruk: ',
    wgTicketInUse:
      'Denne Win Games-billetten er for øyeblikket i bruk og kan ikke innløses før den er logget ut fra maskinen',
    allStatus: 'Alle status',
    openTickets: 'Åpne billetter',
    closedTickets: 'Lukkede billetter',
    searchByName: 'Søk etter navn',
    searchByDate: 'Søk etter dato',
    searchByUsername: 'Søk etter brukernavn',
    time: 'Tid',
    ticketSaleID: 'Billettsalg ID',
    forbiddenAccessTitle:
      'Du har ikke rettigheter til å administrere denne brukeren',
    forbiddenAccessText:
      'Du har ikke de nødvendige rettighetene til å administrere denne brukeren. Hvis du mener dette er en feil, kontakt support.',
    userHasPasswordBlockTitle: 'Denne brukeren er låst',
    userHasPasswordBlockText1:
      'Denne brukeren har blitt låst på grunn av for mange mislykkede påloggingsforsøk.',
    userHasPasswordBlockText2: 'Vil du låse opp brukeren?',
    userHasPasswordUnblockTitle: 'Brukeren er låst opp',
    userHasPasswordUnblockText:
      'Brukeren har blitt låst opp og kan logge inn igjen.',
    salesDisabled:
      'Billettsalg er deaktivert. Den eneste tilgjengelige handlingen er utbetaling.',
  },
  pep: {
    pep: 'PEP',
    customerIsPep: 'Kunden er en PEP',
    customerIsNotPep: 'Kunden er ikke en PEP',
    customerRelativeIsPep: 'Kundens nære familiemedlem er en PEP',
    pepQuestion: 'Er du en politisk eksponert person (PEP)?',
    pepDescription:
      'Du er en PEP hvis du (eller noen i din nærmeste familie) har, eller har hatt, et høytstående verv eller stilling i Norge eller utlandet.',
    pepUncertain: 'Er du usikker på hvilke verv og stillinger?',
    checkList: 'Sjekk listen her',
    positions: [
      'Statsoverhode, regjeringssjef, minister eller assisterende minister',
      'Medlem av nasjonalforsamling',
      'Medlem av styrende organ i politisk parti',
      'Medlem av høyere rettsinstans som treffer beslutning som ikke er bare unntaksvis kan ankes',
      'Medlem av styre i riksrevisjon, revisjonsdomstol eller sentralbank',
      'Amassadør, chargé d’affaires eller militær offiser av høyere rang',
      'Medlem av administrativt, ledende eller kontrollerende organ i statlig foretak',
      'Direktør, styremedlem eller annen person i øverste ledelse i internasjonal organisasjon',
    ],
    pepYes: 'Jeg er PEP',
    pepNo: 'Jeg er ikke PEP',
    tellWhoIsPep: 'Fortell oss hvem som er PEP',
    pepForm: 'PEP-skjema',
    relationshipToPep: 'Din relasjon til PEP',
    name: 'Navn',
    birthDate: 'Fødselsdato',
    gender: 'Kjønn',
    fundsQuestion: 'Hvilke midler skal du spille for?',
    funds: [
      'Lønn',
      'Salg/utleie av eiendom',
      'Salg av aksjer eller fond',
      'Trygd, pensjon, studielån eller andre støtteordninger',
      'Gaver, arv eller lignende',
    ],
    consent: 'Samtykke',
    consentStatements: [
      'Jeg bekrefter at bankkontoer knyttet opp mot min spillekonto for innskudd/inntak står i mitt navn',
      'Jeg bekrefter at midlene jeg skal spille for, inkludert kontanter, er lovlig anskaffet og beskattet',
      'Jeg bekrefter å selv rapportere saldo på spillekonto til myndigheter ved levering av skattemelding',
    ],
    male: 'Mann',
    female: 'Kvinne',
    other: 'Annet',
    required:
      'Du må godta alle samtykker for å fortsette og velge både relasjonen og midlene',
    riskyRequired:
      'Du må godta alle samtykker for å fortsette og velge hvor midlene dine kommer fra',
    userNotReady: 'Brukeren er ikke klar til å fortsette',
  },
  communication: {
    title: 'Hvor kan vi nå deg?',
    subtitle:
      'Velg hvor du ønsker å få nyttig informasjon om gevinst, og annet tilpasset innhold.',
    option1: 'SMS',
    option2: 'Epost',
    option3: 'Få tilpassede tilbud og nyheter på sosiale medier',
    option4: 'Velg alle ovenfor',
  },
  terms: {
    title: 'Vilkår for bruk og personvernerklæring',
    termsText1: 'Jeg har lest og godtar Bingo 1 sine ',
    termsText2: 'vilkår for bruk og personvernerklæring',
    accountText: 'Spillekontoen skal kun benyttes av meg *',
    required: 'Du må godta vilkårene for å fortsette',
  },
  error: {
    errorNotOptionSelected: 'Du må velge en grunn først',
    notEnoughSaldo: 'Bruker har ikke nok saldo på spillekontoen',
    waitingExternalProvider:
      'Venter på ekstern leverandør, vennligst vent et øyeblikk',
    empty: 'Felter skal ikke være tomme',
    login: 'Brukenavn eller passord er feil',
    blockProvider:
      'Det er ikke mulig å selge billetter fra to forskjellige databingoleverandører for samme bruker eller mer enn en billett',
    errorTicketNotSelected:
      'Ingen billett valgt. Du må velge en billett for å fortsette med betalingen.',
    userNotLogin: 'Du må logge på en bruker først',
    userNotMember: 'Denne brukeren er ikke medlem av ClubHouse',
    error:
      'Noe gikk galt. Prøv igjen om et øyeblikk eller kontakt brukerstøtten.',
    errorTooSmall: 'Søket med pinne må ha minst 7 sifre',
    errorPhonenumber: 'Søket etter telefonnummer må være 7 sifre',
    errorPhonenumberInput:
      'Telefonnummeret er ikke gyldig. Bruk et gyldig norsk 8-sifret nummer',
    errorUsernameInput: 'Brukernavn kan ikke være tomt',
    errorCardIDEmpty: 'Kort-ID kan ikke være tom',
    errorCardIDFormat: 'Kort-ID-formatet er feil',
    errorUsernameEmpty: 'Brukernavnet kan ikke være tomt',
    errorUsernameTooShort: 'Brukernavnet er for kort, minimum 5 tegn',
    errorUsernameTooLong: 'Brukernavnet er for langt, maksimum 12 tegn',
    errorFirstnameEmpty: 'Fornavnet kan ikke være tomt',
    errorLastnameEmpty: 'Etternavnet kan ikke være tomt',
    errorAddress1Empty: 'Adressen kan ikke være tom',
    errorPostalCodeEmpty: 'Postnummer kan ikke være tomt',
    errorRegionEmpty: 'Regionen kan ikke være tom',
    errorEmailEmpty: 'E-post kan ikke være tom',
    errorBirthdateEmpty: 'Fødselsdatoen kan ikke være tom',
    errorBirthdateFormat: 'Fødselsdato formatet er feil',
    errorCashOnOpening: 'Kontantbeholdning ved åpning kan ikke være tom',
    errorCashOnClosing: 'Kontantbeholdning ved stenging kan ikke være tom',
    errorVerificationIDEmpty: 'Bekreftelses-ID kan ikke være tom',
    errorVerificationMethodEmpty: 'Bekreftelsesmetoden kan ikke være tom',
    errorPhonenumberExists: 'Telefonnummer allerede registrert',
    errorUsernameExists: 'Brukernavn allerede registrert',
    errorEmailExists: 'E-post allerede registrert',
    errorCardIDExists: 'Kort-ID allerede registrert',
    errorNfcCardIDExists: 'NFC Kort-ID allerede registrert',
    errorSSNIDExists: 'Fødselsnummer allerede registrert',
    errorUserFailCode: 'Koden introdusert av brukeren er ikke korrekt',
    errorRefreshTransactions:
      'Du kan ikke starte kassereren på nytt med ventende transaksjoner',
    errorNavigateTransactions:
      'Du kan ikke bytte skjerm med en bruker som er logget inn eller med pågående transaksjoner',
    errorCode: 'Feilkode',
    errorLimitSize:
      'Den daglige grensen kan ikke være lavere enn den månedlige grensen',
    errorEmptyLimits: 'Begrensningene kan ikke være tomme',
    errorImageRegister:
      'Du må verifisere brukerens bilde før du fullfører registreringen',
    errorSSNIDInvalid: 'Fødselsnummer er ikke gyldig',
    errorSSNIDUnderAge: 'Brukeren er under 18 år',
    errorCancelOpenSell:
      'For å kansellere den valgte transaksjonen, må du fullføre dette salget eller gå tilbake til hovedskjermen',
    errorPEP:
      'Brukeren må bekrefte om han er en P.E.P. eller nært familiemedlem av en P.E.P. for å fortsette',
    errorTermsEmpty: 'Brukeren må godta vilkårene for å fortsette',
    errorCommunicationEmpty:
      'Brukeren må velge kommunikasjonskanaler vi kan bruke',
    errorPincodeEmpty: 'Pinkoden kan ikke være tom',
    errorRiskyEmpty: 'Brukeren må gi ekstra informasjon for å fortsette',
    errorBankAccountEmpty: 'Bankkonto kan ikke være tom',
    errorBankAccountFormat:
      'Bankkonto må være et gyldig norsk kontonummer med 11 sifre (XXXX.XX.XXXXX)',
  },
  sisteSalgs: {
    date: 'Dato',
    bingoName: 'Hall',
    operator: 'Operatør',
    payCard: 'Betalt med kort',
    payCash: 'Betalt med Cash',
    payAccount: 'Betalt med konto',
    total: 'Totalt',
    change: 'Tilbake',
    userID: 'Bruker ID',
    ticket7Pincode: 'Billet Pincode',
    ticketID: 'Billet ID',
    username: 'Brukernavn',
    amount: 'Beløp',
    printed: 'Trykt',
    transactions: 'Se transaksjoner',
    description: 'Beskrivelse',
    printAgain: 'Skriv ut',
    backToSells: 'Tilbake til salg',
  },
  sisteTrans: {
    date: 'Dato',
    bingoName: 'Hall',
    operator: 'Operatør',
    payCard: 'Betalt med kort',
    payCash: 'Betalt med Cash',
    total: 'Totalt',
    change: 'Tilbake',
    ticket7Pincode: 'Billet Pincode',
    ticketID: 'Billet ID',
    username: 'Brukernavn',
    amount: 'Beløp',
    printed: 'Trykt',
    transactions: 'Se transaksjoner',
    description: 'Beskrivelse',
    printAgain: 'Skriv ut',
  },
  ticketHistoric: {
    ticketToSearch: '7-sifret billett for å søke',
    date: 'Dato',
    action: 'Aksjon',
    openSession: 'Åpnet økt',
    closeSession: 'Lukket økt',
    payment: 'Kjøp kort',
    win: 'Vinn premie',
    cancel: 'Avbryt kort',
    deposit: 'Innskudd',
    depositFromPreviousSession: 'Innskudd fra forrige økt',
    saldoInit: 'Startbalanse',
    saldoEnd: 'Endelig balanse',
    bingoName: 'Hall',
    gameID: 'Spill-ID',
    valueChange: 'Verdiendring',
    searchType: 'Søketype',
    userID: 'Bruker-ID',
    phone: 'Telefon',
    username: 'Brukernavn',
    ownerID: 'Billett ID',
    noResults: 'Ingen transaksjoner funnet for denne datoen',
    game: 'Spill / Kilde',
  },
  apneBilleter: {
    date: 'Dato',
    bingoName: 'Hall',
    operator: 'Operatør',
    ticket7Pincode: 'Billet Pincode',
    ticketID: 'Billet ID',
    user7Pincode: 'Bruker',
    description: 'Beskrivelse',
    amount: 'Beløp',
    printAgain: 'Skriv ut',
    seeTransactions: 'Se transaksjoner',
    username: 'Brukernavn',
  },
  menu: {
    search: 'Søk',
  },
  report: {
    startDay: 'Det er ikke åpent økten. Start et nytt nå.',
    startDayButton: 'Start økten.',
    confirm: 'Bekreft',
    edit: ' Rediger',
    cashin: 'Innskudd',
    cashout: 'Uttak',
    neto: 'Neto',
    next: 'Neste',
    back: 'Tilbake',
    picture: ' Bilde',
    errorTicket: 'Du må laste opp billettene først.',
    capturePicture: 'Ta bilde',
    resetCamera: 'Tilbakestill kamera',
    date: 'Dato',
    employee: 'Ansatt',
    miniSafeYesterday: 'Minisafe i går',
    cashierYesterday: 'Kassebeholding i går',
    cashierInOpening: 'Kassebeholdning ved åpning',
    difference: 'Differanse',
    cashierTotal: 'Kasse totalt',
    cashierRefill: 'Kassepåfyll',
    sendReport: 'Send rapport',
    theoric: 'Teoretisk',
    minisafe: 'Minisafe',
    cashier: 'Kassebeholding',
    deviated: 'Avvik',
    acceptDeviated: 'Godkjenner avvik',
    closeReport: 'Dagsrapport slutt',
  },
  endShift: {
    mainTitle: 'Avslutt skift rapport',
    mainSubtitle:
      'Bekreft avslutningen av skiftet ditt vil automatisk håndtere alle rapportene og skrive ut kvitteringene. Vil du fortsette?',

    title: 'Velg ett av alternativene:',
    subtitle:
      'Du må gjøre begge deler, kortterminalrapporten og daglig kasserapport',
    cardReport: 'Kortterminal rapport',
    cashierReport: 'Clubhouse Rapport',
    winGamesReport: 'Win Games Rapport',
    completed: 'Fullført',
    notCompleted: 'Ikke fullført',
    confirmCardReport: 'Vil du bekrefte kortterminalrapporten?',
    confirmWinGamesReport: 'Vil du bekrefte Win Games rapporten?',
    cashin: 'Sett inn penger',
    cashout: 'Ta ut penger',
    neto: 'Netto',
    cardPayment: 'Betaling med kort',
    cardPayout: 'Kontant uttak',
    cardTotal: 'Totalt med kort',
    waiting: 'Behandler rapporten, vent et øyeblikk.',
    currentShift: 'Nåværende skift',
    day: 'Hele dagen',
    cashierSection: 'Kasse',
    selfKioskSection: 'Selvbetjening',
    totalSection: 'Totalt',
    refunds: 'Refusjoner',
    paymentCash: 'Kontantbetaling',
    paymentCard: 'Kortbetaling',
    paymentAccount: 'Spillerkonto',
    choiceTitle: 'Avslutt skiftet',
    choiceSubtitle: 'Hva vil du gjøre?',
    closeShift: 'Lukk skift',
    closeDay: 'Lukk dagen',
    cashOnClosing: 'Kontantbeholdning ved stenging',
    back: 'Tilbake',

    // Opptelling av kassen — the count, the discrepancy and the signature
    countTitle: 'Opptelling av kassen',
    countSubtitle: 'Tell opp skuffen og skriv inn beløpet du faktisk teller.',
    countedLabel: 'Telt beløp',
    countedHelp: 'Tell før du ser hva kassen forventer.',
    showAvvik: 'Vis avvik',
    expected: 'Forventet',
    expectedUnknown: 'Ikke tilgjengelig',
    avvik: 'Avvik',
    avvikOver: 'Overskudd i kassen',
    avvikUnder: 'Manko i kassen',
    avvikNone: 'Kassen stemmer',
    avvikCommentLabel: 'Forklaring på avviket',
    avvikCommentHelp:
      'Tell opp en gang til, eller skriv hva som forklarer avviket.',
    avvikCommentRequired: 'Et avvik må forklares før skiftet kan lukkes.',
    recount: 'Tell på nytt',
    ntNetto: 'NT netto',
    rikstotoNetto: 'Rikstoto netto',
    externalTillHelp:
      'Les av nettobeløpet i NT og Rikstoto og skriv det inn. Null er null, men det må fylles ut.',
    externalNettoRequired: 'NT og Rikstoto må fylles ut, også når de er null.',
    signTitle: 'Signering',
    signedByLabel: 'Navn',
    signedByHelp: 'Skriv navnet ditt slik det skal stå på kvitteringen.',
    signConfirm:
      'Jeg bekrefter at jeg har telt kassen og at beløpet over stemmer.',
    signRequired: 'Skriv navnet ditt og bekreft opptellingen.',
    countMissing: 'Skriv inn det telte beløpet.',
    draftRestored: 'Gjenopprettet en opptelling som ikke ble fullført.',
    noOpenShift: 'Fant ingen åpent skift å lukke.',
  },
  safe: {
    title: 'Safe og mini safe',
    miniSafe: 'Mini safe',
    safe: 'Safe',
    miniSafeIn: 'Sett inn',
    miniSafeOut: 'Ta ut',
    miniSafeCount: 'Tell opp',
    countedToday: 'Talt opp i dag',
    notCountedToday: 'Ikke talt opp i dag',
    newBag: 'Ny pengepose',
    toBank: 'Til banken',
    toBankSummary: '{{count}} poser til banken, {{total}} kr til sammen.',
    bagCount: '{{count}} poser i safen',
    noBags: 'Ingen poser i safen.',
    noBagsSelected: 'Velg minst \u00e9n pose.',
    bagNotFound: 'Posen finnes ikke lenger i safen.',
    amount: 'Bel\u00f8p',
    countedLabel: 'Telt bel\u00f8p',
    reason: '\u00c5rsak',
    note: 'Merknad',
    reference: 'Referanse',
    referenceHelp: 'Bilagsnummer eller innskuddsreferanse, om dere har en.',
    reasonHelp: 'Skriv hvorfor pengene flyttes. Kort holder.',
    countHelp: 'Tell mini safen og skriv bel\u00f8pet du faktisk finner.',
    amountRequired: 'Skriv inn et bel\u00f8p.',
    reasonRequired: '\u00c5rsak m\u00e5 fylles ut.',
    insufficientBalance: 'Det er ikke nok i mini safen.',
    moveDone: 'Bevegelsen er registrert.',
    countDone: 'Opptellingen er registrert.',
    bagCreated: 'Pengeposen er lagt i safen.',
    bagsBanked: 'Posene er sendt til banken.',
    bagCancelled: 'Pengeposen er angret.',
  },
  avslutteSkiftet: {
    closeTurn: 'Avslutt skift',
    openTickets: 'Åpne billetter',
    yourTurn: 'Ditt skift',
    totalToday: 'Totalt i dag',
    paymentCash: 'Kontantbetaling',
    paymentCard: 'Kortbetaling',
    paymentAccount: 'Kontobetaling',
    in: 'Inn',
    out: 'Ut',
    net: 'Netto',
    provider: 'Leverandør',
    amount: 'Beløp',
    date: 'Dato',
    ticketID: 'Billett-ID',
    closeOpenTicketsBtn: 'Lukk billetter',
    closeTurnTitle: 'Avslutt ditt skift',
    closeTurnText1:
      'Du er i ferd med å avslutte ditt skift, vil du fortsette? Det vil skrive ut rapportene.',
    closeTurnText2:
      'Hvis du er det siste skiftet for dagen, vennligst lukk alle åpne billetter før du avslutter ditt skift.',
    closeTurnConfirm: 'Ditt skift har blitt avsluttet.',
    closeOpenTicketsTitle: 'Lukk åpne billetter',
    closeOpenTicketsText1:
      'Du er i ferd med å lukke alle åpne billetter. Dette vil tømme saldoen for alle billettene. Vil du fortsette?',
    closeOpenTicketsText2:
      'Vennligst vær oppmerksom på at bingoen skal være avsluttet, og at ingen spiller.',
    closeOpenTicketsText3: 'OK D.-billetter må lukkes manuelt.',
    closeOpenTicketsConfirm: 'Alle billetter har blitt lukket.',
    notOpenTickets: 'Det er ingen åpne billetter.',
  },
  socketStatus: {
    disconnectTitle: 'Tilkobling tapt',
    disconnectText:
      'Tilkoblingen til serveren har blitt brutt. Prøver å koble til igjen, vent eller kontakt support.',
    reconnectTitle: 'Tilkoblet igjen',
    reconnectTextNoTransactions:
      'Tilkoblingen til serveren har blitt gjenopprettet. Vi anbefaler at du oppdaterer kassen.',
    reconnectTextTransactions:
      'Tilkoblingen til serveren har blitt gjenopprettet. Vi anbefaler at du oppdaterer kassen etter å ha fullført de pågående transaksjonene.',
    refresh: 'Oppdater nå',
    notRefresh: 'Ikke oppdater',
  },
  gameplan: {
    name: 'Navn',
    dateStart: 'Startdato',
    gameID: 'Spill-ID',
    priceCard: 'Pris kort',
    printDraw: 'Skriv ut spill',
    winners: 'Vinnere',
    rop: 'Rop',
    cardNumber: 'Kortnummer',
    userID: 'Bruker-ID',
    bingoName: 'Bingonavn',
    playFrom: 'Spilt fra',
    win: 'Gevinst',
    dateEnd: 'Sluttid',
    prizeType: 'Gevinsttype',
    username: 'Brukernavn',
    firstname: 'Fornavn',
    lastname: 'Etternavn',
    phone: 'Telefon',
    guest: 'Gjest',
    viaTicket: 'billett',
  },
};
